var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04345 1C1.46738 1 1 1.47524 1 2.06027V2.6843C1 3.11765 1.16479 3.53439 1.45957 3.84785L4.69007 7.28288L4.69149 7.28072C5.31514 7.91919 5.66604 8.78228 5.66604 9.68221V12.7301C5.66604 12.9338 5.87913 13.0638 6.056 12.9677L7.8957 11.9653C8.17343 11.8136 8.34675 11.5189 8.34675 11.1989V9.67427C8.34675 8.77939 8.69267 7.91991 9.31064 7.28288L12.5411 3.84785C12.8352 3.53439 13 3.11765 13 2.6843V2.06027C13 1.47524 12.5333 1 11.9573 1H2.04345Z",
    stroke: "url(#paint0_linear_4233_2843)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4233_2843",
    x1: 1,
    y1: 7.07595,
    x2: 13.1915,
    y2: 7.07595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D592"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.f25f694f7c6cf14fa1b39f68289f963a.svg";
export { ForwardRef as ReactComponent };